var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1081_3125)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.7391 23.1124L8.66783 27.3568C7.18061 27.619 5.76242 26.626 5.5002 25.1388L2.85059 10.1123C2.58836 8.62504 3.58142 7.20686 5.06858 6.94463L29.1398 2.7002C30.627 2.43797 32.0452 3.43103 32.3075 4.91819L34.9571 19.9447C35.2194 21.4319 34.2263 22.8502 32.7391 23.1124Z",
    fill: "#3555A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1411 2.7002L17.1055 4.82242L20.7047 25.2347L32.7403 23.1124C34.2275 22.8502 35.2206 21.432 34.9583 19.9448L32.3087 4.91825C32.0465 3.43103 30.6283 2.43797 29.1411 2.7002Z",
    fill: "#1B3555"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6602 32.3411H2.73438C1.22425 32.3411 0 31.1168 0 29.6067V14.7236C0 13.2135 1.22425 11.9893 2.73438 11.9893H26.6602C28.1703 11.9893 29.3945 13.2135 29.3945 14.7236V29.6067C29.3945 31.1168 28.1703 32.3411 26.6602 32.3411Z",
    fill: "#53D8E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6602 11.9893H14.6973V32.3411H26.6602C28.1703 32.3411 29.3945 31.1168 29.3945 29.6067V14.7236C29.3945 13.2135 28.1703 11.9893 26.6602 11.9893Z",
    fill: "#18A8C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 16.6416H29.3945V21.2935H0V16.6416Z",
    fill: "#ECF6FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.14014 27.8271H3.48828C2.92199 27.8271 2.46289 28.2862 2.46289 28.8525C2.46289 29.4188 2.92199 29.8779 3.48828 29.8779H8.14014C8.70643 29.8779 9.16553 29.4188 9.16553 28.8525C9.16553 28.2862 8.70643 27.8271 8.14014 27.8271Z",
    fill: "#EAF6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6973 16.6416H29.3945V21.2935H14.6973V16.6416Z",
    fill: "#D6E8FE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1081_3125"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/Card.b5c2f2598f4042567210fda1111e3147.svg";
export { ForwardRef as ReactComponent };